import { Divider, Paper, Table } from "@mantine/core";
import { formatPercent } from "common/utils";
import { CustomNumberInput } from "pages/admin/components/CustomNumberInput2";
import React from "react";
import { ProductManagementChildFormProps } from "types/interface.types";

const ProductDetailsCard2: React.FC<ProductManagementChildFormProps> = ({
  readonly,
  formApi,
}) => {
  const { values, setFieldValue } = formApi;

  return (
    <div className="card-container ">
      <Paper
        radius="md"
        shadow="md"
        withBorder
        style={{
          overflow: "hidden",
          maxHeight: "60vh",
          background: "white",
        }}
      >
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th></Table.Th>
              <Table.Th className="alignc" colSpan={4}>
                Sell Price
              </Table.Th>
              <Table.Th className="alignc" colSpan={2}>
                Buy Price
              </Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            <Table.Tr>
              <Table.Td></Table.Td>
              <Table.Td>Price #1</Table.Td>
              <Table.Td>Price #2</Table.Td>
              <Table.Td>Price #3</Table.Td>
              <Table.Td>Price #4</Table.Td>
              <Table.Td>Retail</Table.Td>
              <Table.Td>Cost</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th></Table.Th>
              <Table.Td>
                <CustomNumberInput
                  readonlyMode={readonly}
                  placeholder=""
                  value={values.sellPrice1}
                  onChange={(v) => setFieldValue("sellPrice1", v)}
                />
              </Table.Td>
              <Table.Td>
                <CustomNumberInput
                  readonlyMode={readonly}
                  placeholder=""
                  value={values.sellPrice2}
                  onChange={(v) => setFieldValue("sellPrice2", v)}
                />
              </Table.Td>
              <Table.Td>
                <CustomNumberInput
                  readonlyMode={readonly}
                  placeholder=""
                  value={values.sellPrice3}
                  onChange={(v) => setFieldValue("sellPrice3", v)}
                />
              </Table.Td>
              <Table.Td>
                <CustomNumberInput
                  readonlyMode={readonly}
                  placeholder=""
                  value={values.sellPrice4}
                  onChange={(v) => setFieldValue("sellPrice4", v)}
                />
              </Table.Td>
              <Table.Td>
                <CustomNumberInput
                  readonlyMode={readonly}
                  placeholder=""
                  value={values.retail}
                  onChange={(v) => setFieldValue("retail", v)}
                />
              </Table.Td>
              <Table.Td>
                <CustomNumberInput
                  readonlyMode={readonly}
                  placeholder=""
                  value={values.costPrice}
                  onChange={(v) => setFieldValue("costPrice", v)}
                />
              </Table.Td>
            </Table.Tr>
            <Table.Tr className="em">
              <Table.Td>GP %</Table.Td>
              <Table.Td>{formatPercent(values.gp1, 0, false)}</Table.Td>
              <Table.Td>{formatPercent(values.gp2, 0, false)}</Table.Td>
              <Table.Td>{formatPercent(values.gp3, 0, false)}</Table.Td>
              <Table.Td>{formatPercent(values.gp4, 0, false)}</Table.Td>
              <Table.Td></Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </Paper>
      <Divider size={"sm"} my="lg" />
      <Paper
        radius="md"
        shadow="md"
        withBorder
        style={{
          overflow: "hidden",
          maxHeight: "60vh",
          background: "white",
        }}
      >
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th colSpan={2} className="alignc">
                Stock on Hand (min: units)
              </Table.Th>
              <Table.Th colSpan={2} className="alignc">
                Customer Orders
              </Table.Th>
              <Table.Th colSpan={2} className="alignc">
                Supplier Orders
              </Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            <Table.Tr>
              <Table.Td>Units</Table.Td>
              <Table.Td>Cartons</Table.Td>
              <Table.Td>Ordered</Table.Td>
              <Table.Td>Back Orders</Table.Td>
              <Table.Td>Pending</Table.Td>
              <Table.Td>Confirmed</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td>
                {readonly ? (
                  <>{values.onHand}</>
                ) : (
                  <>
                    <CustomNumberInput
                      readonlyMode={readonly}
                      wholeNumber={true}
                      placeholder=""
                      value={values.onHand}
                      onChange={(v) => setFieldValue("onHand", v)}
                    />
                  </>
                )}
              </Table.Td>
              <Table.Td>{values.onHandCtn}</Table.Td>
              <Table.Td>{values.ordered}</Table.Td>
              <Table.Td>{values.backOrder}</Table.Td>
              <Table.Td>{values.pendingOrder}</Table.Td>
              <Table.Td>{values.confirmedOrder}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="alignc" colSpan={6}>
                <em>NOTE:</em> Customer Orders are based on count since 1st of
                January of current year...
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </Paper>
    </div>
  );
};
export default React.memo(ProductDetailsCard2);
